// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"Confirm_modalContent_3mFLb","title":"Confirm_title_3gKGf","modalButtons":"Confirm_modalButtons_1qAiQ","no":"Confirm_no_2Ji91"};